const serverBackendUrl = process.env.BACKEND_URL
const publicBackendUrl = process.env.NEXT_PUBLIC_BACKEND_URL

const ensureProtocol = (value: string): string => {
  if (!value) {
    return value
  }

  if (/^https?:\/\//.test(value)) {
    return value
  }

  return `https://${value}`
}

const normalizeBackendUrl = (value: string | undefined): string => {
  return ensureProtocol((value || "").trim().replace(/\/+$/, ""))
}

const resolvedBackendUrl = normalizeBackendUrl(
  serverBackendUrl || publicBackendUrl || "http://localhost:4000"
)

export const API_BASE_URL = resolvedBackendUrl
